<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="campaigncharts" *ngIf="data != null">
        <div class="ui-g-12 ui-md-12 ui-sm-12">
            <h2>{{ translations.ripartionPromo }}</h2>
            <div class="chart-container">
                <chart [options]="ripartionPromoChart.options"
                       (load)="setChartInstance(ripartionPromoChart, $event.context)"></chart>
            </div>
        </div>
    </div>


    <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="data != null">
        <p-table [value]="datatable" class="overview-table" sortMode="multiple">

            <ng-template pTemplate="header">
                <tr>
                    <th [pSortableColumn]="'nomePromo'">
                        <span class="sortableCol">{{ translations.nomePromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'nomePromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'typePromo'">
                        <span class="sortableCol">{{ translations.typePromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'typePromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'startPromo'">
                        <span class="sortableCol">{{ translations.startPromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'startPromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'endPromo'">
                        <span class="sortableCol">{{ translations.endPromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'endPromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'investmentPromo'">
                        <span class="sortableCol">{{ translations.investmentPromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'investmentPromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'invoicePromo'">
                        <span class="sortableCol">{{ translations.invoicePromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'invoicePromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'expensePromo'">
                        <span class="sortableCol">{{ translations.expensePromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'expensePromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'discountPromo'">
                        <span class="sortableCol">{{ translations.discountPromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'discountPromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'quantityPromo'">
                        <span class="sortableCol">{{ translations.quantityPromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'quantityPromo'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'adhesionPromo'">
                        <span class="sortableCol">{{ translations.adhesionPromo }}</span>
                        <p-sortIcon class="sortableIcon" [field]="'adhesionPromo'"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-col>
                <tr>
                    <td class="number-column">{{ col.nomePromo }}</td>
                    <td class="number-column">{{ col.typePromo }}</td>
                    <td class="number-column">{{ col.startPromo }}</td>
                    <td class="number-column">{{ col.endPromo }}</td>
                    <td class="number-column">{{ col.investmentPromo }}</td>
                    <td class="number-column">{{ col.invoicePromo }}</td>
                    <td class="number-column">{{ col.expensePromo }}</td>
                    <td class="number-column">{{ col.discountPromo }}</td>
                    <td class="number-column">{{ col.quantityPromo }}</td>
                    <td class="number-column">{{ col.adhesionPromo }}</td>
                </tr>
            </ng-template>

        </p-table>
    </div>

    <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-promo/analysis-promo.component.html